
import { Component, Mixins } from "vue-property-decorator";
import { IEditCommandManageable } from "../../../.././domain/system/edit";

@Component
export default class EditCommandManageableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  readPropertyOrDefault: <T>(reader: (source: IEditCommandManageable) => T, defaultValue: T) => T;
  writePropertyWhenValid: (writer: (source: IEditCommandManageable) => void) => void;

  get hasDoneCommand(): boolean {
    return this.readPropertyOrDefault(s => s.hasDoneCommands(), false);
  }

  get hasUndoneCommand(): boolean {
    return this.readPropertyOrDefault(s => s.hasUndoneCommands(), false);
  }

  undo(): void {
    // 入力中にundoした時に順番おかしくなる懸念あり.1ループ遅らせる.
    this.$nextTick().then(() => {
      this.writePropertyWhenValid(s => s.undo());
    });
  }

  redo(): void {
    // 入力中にredoした時に順番おかしくなる懸念あり.1ループ遅らせる.
    this.$nextTick().then(() => {
      this.writePropertyWhenValid(s => s.redo());
    });
  }
}
